/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailPreview
 */
export interface EmailPreview {
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof EmailPreview
     */
    styling?: { [key: string]: string | undefined; };
}

export function EmailPreviewFromJSON(json: any): EmailPreview {
    return EmailPreviewFromJSONTyped(json, false);
}

export function EmailPreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailPreview {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'styling': !exists(json, 'styling') ? undefined : json['styling'],
    };
}

export function EmailPreviewToJSON(value?: EmailPreview | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'styling': value.styling,
    };
}


